var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadCsv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.35,
    clipPath: "url(#clip0_5917_16655)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.37411 20.3125H7.03036C6.25493 20.3115 5.48857 20.1457 4.78213 19.8259C4.07569 19.5062 3.44532 19.0399 2.93286 18.4579C2.42039 17.876 2.03754 17.1917 1.80972 16.4505C1.58189 15.7093 1.5143 14.9281 1.61143 14.1588C1.70855 13.3895 1.96817 12.6496 2.37306 11.9882C2.77795 11.3269 3.31886 10.7593 3.95988 10.3229C4.6009 9.88659 5.32738 9.59157 6.09112 9.45744C6.85487 9.32331 7.6384 9.35312 8.38974 9.54492",
    stroke: "#1A1A1A",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.8125 12.5C7.8125 11.2621 8.10667 10.0419 8.67076 8.94C9.23485 7.83808 10.0527 6.88599 11.057 6.16217C12.0612 5.43836 13.2231 4.96354 14.4468 4.77685C15.6706 4.59017 16.9211 4.69695 18.0955 5.08841C19.2699 5.47987 20.3345 6.1448 21.2014 7.0284C22.0684 7.912 22.713 8.98897 23.0821 10.1706C23.4512 11.3522 23.5343 12.6046 23.3244 13.8245C23.1145 15.0445 22.6177 16.1972 21.875 17.1875",
    stroke: "#1A1A1A",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 18.6875L15.125 21.8125L18.25 18.6875",
    stroke: "#1A1A1A",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.125 14V21.8125",
    stroke: "#1A1A1A",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5917_16655"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadCsv);
export default __webpack_public_path__ + "static/media/download-csv.ce78bc3c.svg";
export { ForwardRef as ReactComponent };